import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import { FaHome, FaTasks, FaBell, FaSignOutAlt } from 'react-icons/fa';

// Logos will be loaded from public folder
import { logout } from '../../../store/session';
import balanceService from '../../../utils/balanceService';

import './LeftSideBar.css';


const LeftSideBar = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.session.user);
  const [currentBalance, setCurrentBalance] = useState(user?.balance || 0);

  // Update balance from balanceService to match the BalanceCard
  useEffect(() => {
    if (user?.id) {
      const updatedBalance = balanceService.getUserBalance(user.id);
      setCurrentBalance(updatedBalance);
    }
  }, [user?.id]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
  };

  if (!user) {
    return null;
  };

  return (
    <div className="left-side-bar">
      <Link to='/'>
        <img src="/images/venmo-logo.svg" alt='logo' className='leftLogo' />
      </Link>
      <div className="user-info">
        <div className="profile-pic"></div>
        <div className="user-welcome">
          Hi, {user.name}
          <div className="usertag">
            @{user.username}
          </div>
        </div>
      </div>
      <div className="balance">
        <p>$ {currentBalance.toFixed(2)} in Venmo</p>
      </div>
      <Link className="nav-item" to='/'>
        <FaHome /> Home
      </Link>
      <Link className="incomplete" to='/incomplete'>
        <FaTasks /> Incomplete
      </Link>
      <Link className="notification" to='/notification'>
        <FaBell /> Notifications
      </Link>
      <div onClick={handleLogout} className="logout">
        <FaSignOutAlt /> Logout
      </div>
      {window.location.href.split('/')[3] !=='pay' ?
        <Link className="pay-btn getVenmo btn no-change-color" to='/pay'>
          <img src="/images/solid-color-logo.png" className='solid-color-logo' alt='solid-color-logo'/>
          Pay or Request
        </Link>
        :
        <></>
      }
    </div>
  )
}

export default LeftSideBar;
